import { useParams } from '@tanstack/react-router';

type RouteParams = ReturnType<typeof useRouteParams>;

const useRouteParams = () => useParams({ strict: false });

/**
 * Pages mounted under a route that carries a parameter always receive it, but
 * `useParams` with `strict: false` types every parameter as optional because it
 * can be called from any route. This is the one place that knows better, and
 * the throw keeps that claim honest rather than letting an absent value reach a
 * request url.
 */
export const useRequiredParam = <Name extends keyof RouteParams>(
  name: Name,
): NonNullable<RouteParams[Name]> => {
  const value = useRouteParams()[name];
  if (value === undefined) {
    throw new Error(`This route does not carry a "${String(name)}" parameter`);
  }
  return value;
};

export const useParamsId = (): string => useRequiredParam('id');
